module.exports = __webpack_public_path__ + "static/media/right.928e25eb.svg";